import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useViewportOffsetVar } from "@/lib/whatsapp";

const KEY = "wafa.cookie-consent.v1";

function loadGA(measurementId) {
  if (!measurementId) return;
  if (document.getElementById("ga4-loader")) return;
  const s1 = document.createElement("script");
  s1.id = "ga4-loader";
  s1.async = true;
  s1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(s1);
  const s2 = document.createElement("script");
  s2.innerHTML = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${measurementId}');`;
  document.head.appendChild(s2);
}

export function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID || "";
  const ref = useRef(null);
  useViewportOffsetVar(ref, "--cookie-top", visible);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) {
      setVisible(true);
      return;
    }
    if (stored === "accepted") {
      loadGA(gaId);
    }
  }, [gaId]);

  // Re-open handler: the Cookie Settings link in the footer (and the
  // Cookie Policy page) dispatch this event. Clearing the stored choice
  // so the banner behaves as a fresh visit.
  useEffect(() => {
    const onOpen = () => {
      localStorage.removeItem(KEY);
      setVisible(true);
    };
    window.addEventListener("wafa:open-cookie-settings", onOpen);
    return () => window.removeEventListener("wafa:open-cookie-settings", onOpen);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    loadGA(gaId);
    setVisible(false);
  };
  const reject = () => {
    localStorage.setItem(KEY, "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      ref={ref}
      data-testid="cookie-consent"
      className="fixed inset-x-4 bottom-[calc(var(--mobile-bar-h,0px)+12px)] z-40 rounded-lg border border-wafa-deep/15 bg-white p-4 shadow-lg md:bottom-6 md:start-6 md:end-auto md:max-w-md md:p-5"
      role="dialog"
      aria-live="polite"
    >
      <h3 className="font-heading text-base font-semibold text-wafa-deep">
        We use cookies to improve your visit.
      </h3>
      <p className="mt-2 text-xs leading-relaxed text-wafa-ink/70">
        Nothing non-essential fires until you agree. See our{" "}
        <Link to="/cookie-policy" className="underline underline-offset-2">
          cookie policy
        </Link>{" "}
        for what we track.
      </p>
      <div className="mt-4 flex items-center gap-2">
        <button
          data-testid="cookie-accept"
          onClick={accept}
          className="rounded-md bg-wafa-primary px-4 py-2 text-xs font-semibold text-white transition-colors hover:bg-wafa-deep"
        >
          Accept
        </button>
        <button
          data-testid="cookie-reject"
          onClick={reject}
          className="rounded-md border border-wafa-deep/15 px-4 py-2 text-xs font-medium text-wafa-deep transition-colors hover:bg-wafa-cream/60"
        >
          Reject non-essential
        </button>
      </div>
    </div>
  );
}
